import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {BzDialogRef} from '@bringoz/ui';
import {bzIconInfoOutline} from '@bringoz/ui/icons';
import {ExportPayrollDialogResult} from '../../../types/timekeeping-dialog.type';

/**
 * Confirms a payroll export and what to do with the timecards it covers.
 */
require('../timekeeping-dialogs.scss');
@Component({
  standalone: false,
  selector: 'app-timekeeping-export-payroll-dialog',
  templateUrl: './timekeeping-export-payroll-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimekeepingExportPayrollDialogComponent {

  private readonly ref = inject<BzDialogRef<ExportPayrollDialogResult>>(BzDialogRef);

  readonly icons = {info: bzIconInfoOutline};
  readonly completeApproved = signal(true);
  readonly archiveNotApproved = signal(true);

  onCancel() {
    this.ref.close();
  }

  onConfirm() {
    this.ref.close({
      completeApproved: this.completeApproved(),
      archiveNotApproved: this.archiveNotApproved()
    });
  }
}
